import React from 'react';

export const MixerSection = ({ tracks, onVolumeChange, onPanChange, onMute, onSolo, selectedTrackId, onSelectTrack }) => {
  return (
    <div className="h-full flex items-stretch px-2 py-3 overflow-x-auto">
      {tracks.length === 0 && (
        <div className="flex items-center justify-center w-full text-gray-500 text-sm">
          Add tracks to see the mixer
        </div>
      )}
      
      {tracks.map((track, idx) => (
        <div
          key={track.id}
          onClick={() => onSelectTrack(track.id)}
          className={`w-20 shrink-0 mx-1 rounded-lg p-2 flex flex-col items-center cursor-pointer ${selectedTrackId === track.id ? 'bg-[#252525] ring-1 ring-blue-500' : 'bg-[#1a1a1a] hover:bg-[#202020]'}`}
          data-testid={`mixer-ch-${idx}`}
        >
          {/* Track Color */}
          <div className="w-full h-1 rounded-full mb-2" style={{ backgroundColor: track.color }} />
          
          {/* VU Meter Placeholder */}
          <div className="w-4 h-20 bg-[#0a0a0a] rounded mb-2 relative overflow-hidden">
            <div
              className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-500 via-yellow-400 to-red-500 transition-all"
              style={{ height: `${track.volume * 100}%` }}
            />
          </div>
          
          {/* Volume Fader */}
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={track.volume}
            onChange={(e) => onVolumeChange(track.id, parseFloat(e.target.value))}
            onClick={(e) => e.stopPropagation()}
            className="w-full h-2 accent-blue-500 mb-2"
            style={{ writingMode: 'bt-lr', WebkitAppearance: 'slider-vertical', height: '60px', width: '20px' }}
          />
          
          {/* Pan Knob (simplified as slider) */}
          <div className="text-[9px] text-gray-500 mb-1">Pan</div>
          <input
            type="range"
            min="-1"
            max="1"
            step="0.1"
            value={track.pan}
            onChange={(e) => onPanChange(track.id, parseFloat(e.target.value))}
            onClick={(e) => e.stopPropagation()}
            className="w-12 h-1 accent-gray-400"
          />
          
          {/* M/S */}
          <div className="flex gap-1 mt-2">
            <button onClick={(e) => { e.stopPropagation(); onMute(track.id); }} className={`w-5 h-5 rounded text-[8px] font-bold ${track.muted ? 'bg-red-500 text-white' : 'bg-[#333] text-gray-500'}`}>M</button>
            <button onClick={(e) => { e.stopPropagation(); onSolo(track.id); }} className={`w-5 h-5 rounded text-[8px] font-bold ${track.solo ? 'bg-yellow-500 text-black' : 'bg-[#333] text-gray-500'}`}>S</button>
          </div>
          
          {/* Track Name */}
          <div className="text-[9px] text-center mt-1 truncate w-full text-gray-400">{track.name}</div>
        </div>
      ))}
      
      {/* Master Channel */}
      {tracks.length > 0 && (
        <div className="w-20 shrink-0 mx-1 rounded-lg p-2 flex flex-col items-center bg-[#252525] border border-[#444]">
          <div className="w-full h-1 rounded-full mb-2 bg-white" />
          <div className="w-4 h-20 bg-[#0a0a0a] rounded mb-2 relative overflow-hidden">
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-green-500 via-yellow-400 to-red-500" style={{ height: '70%' }} />
          </div>
          <div className="h-[60px]" />
          <div className="text-[9px] text-white font-bold mt-auto">MASTER</div>
        </div>
      )}
    </div>
  );
};

export default MixerSection;
